import { ec_enUS as ec } from './module/ec';
import { marketing_enUS as marketing } from './module/marketing';
import { adjustment_enUS as adjustment } from './module/adjustment';
import { report_enUS as report } from './module/report';
import { wechat_enUS as wechat } from './module/wechat';
import { goods_enUS as goods } from './module/goods';
import { cm_enUS as cm } from './module/cm';
import { blackList_enUS as blackList } from './module/blackList';
import { coupon_enUS as coupon } from './module/coupon';
import { coupon_enUS as coupon2 } from './module/coupon2';
import { message_enUS as message } from './module/message';
import { order_enUS as order } from './module/order';

export default {
  'comm.date.lbl.01': `DAY`, //天
  'comm.date.lbl.02': `D`, //天
  'comm.date.lbl.03': `DAY`, //日
  'comm.date.lbl.04': `WEEK`, //周
  'comm.date.lbl.05': `MONTH`, //月
  'comm.amount.lbl.01': `YUAN`, //元
  'comm.time.lbl.01': `SECOND`, //秒
  'comm.time.lbl.02': `H`, //时
  'comm.pagination.lbl.01': `TOTAL`, //总计
  'comm.pagination.lbl.02': `ITEMS`, //商品
  'comm.pagination.lbl.03': `PREVIOUS`, //上一页
  'comm.pagination.lbl.04': `NEXT`, //下一页
  'comm.pagination.lbl.05': `PAGE`, //页
  'comm.pagination.lbl.06': `ARTICLE`, //条
  'comm.action.btn.01': `SEARCH`, //查询
  'comm.action.btn.02': `ADD`, //新增
  'comm.action.btn.03': `EDIT`, //编辑
  'comm.action.btn.04': `DELETE`, //删除
  'comm.action.btn.05': `DETAIL`, //详情
  'comm.action.btn.06': `RESET`, //重置
  'comm.action.btn.07': `CONFIRM`, //确认
  'comm.action.btn.08': `CANCEL`, //取消
  'comm.action.btn.09': `DATA`, //数据
  'comm.action.btn.10': `PAUSE`, //暂停
  'comm.action.btn.11': `STOP`, //终止
  'comm.action.btn.12': `VERIFY`, //审核
  'comm.action.btn.13': `NEXT`, //下一步
  'comm.action.btn.14': `PREVIOUS`, //上一步
  'comm.action.btn.15': `ADD NOW`, //立即新建
  'comm.action.btn.16': `EXIT`, //退出
  'comm.action.btn.17': `COMPLETE`, //完成
  'comm.action.btn.18': `RESTART`, //重启
  'comm.action.btn.19': ``, //立即发送
  'comm.action.btn.20': `IMPORT`, //导入
  'comm.action.btn.21': `DOWNLOAD`, //下载
  'comm.action.btn.22': `Add`, //添加

  'comm.month.lbl.1': `JAN.`, //1月
  'comm.month.lbl.2': `FEB.`, //2月
  'comm.month.lbl.3': `MAR.`, //3月
  'comm.month.lbl.4': `APR.`, //4月
  'comm.month.lbl.5': `MAY`, //5月
  'comm.month.lbl.6': `JUN.`, //6月
  'comm.month.lbl.7': `JUL.`, //7月
  'comm.month.lbl.8': `AUG.`, //8月
  'comm.month.lbl.9': `SEPT.`, //9月
  'comm.month.lbl.10': `OCT.`, //10月
  'comm.month.lbl.11': `NOV.`, //11月
  'comm.month.lbl.12': `DEC.`, //12月
  'comm.msg.txt.01': `NO DATA.`, //暂无数据
  'comm.msg.txt.02': `SERVER UNREACHABLE…`, //服务器开小差了…
  'comm.chart.lbl.01': `TTL`, //总
  'comm.chart.lbl.02': `AVG.`, //平均
  'comm.chart.lbl.03': `BOT(S)`, //瓶
  'comm.chart.lbl.04': `PEOPLE`, //人
  'comm.chart.lbl.05': `TIME(S)`, //次
  'comm.chart.lbl.06': `PAGE`, //页
  'comm.chart.lbl.07': `OFF`, //折
  'comm.chart.lbl.08': `TIMES`, //倍
  'comm.chart.lbl.09': `POINTS`, //分
  'comm.chart.lbl.10': `piece(s)`, //张
  'comm.dcz.txt.01': `REPORT UP TO: {DATA} 23:59`, //数据统计截止：{data}  23:59

  'ec.menu': `EC`, //会员指数盘
  'ec.dashboard.menu': `DASHBOARD`, //概览
  'cm.menu': `OFFLINE STORE/WEBSITE/SMALL PROGRAM`, //客户管理
  'cm.member.menu': `MEMBERSHIP MANAGEMENT`, //会员管理
  'cm.member.detail.menu': `MEMBERSHIP DETAILS`, //会员详情
  'cm.search.menu': `MEMBERSHIP SEARCH`, //会员查询
  'cm.analysis.menu': `MEMBERSHIP ANALYSIS`, //会员分析
  'cm.black.menu': `BLACKLIST`, //黑名单
  'order.menu': `ORDER`, //订单管理
  'order.order.menu': `ORDER MANAGEMENT`, //订单管理
  'order.order.detail.menu': `ORDER DETAILS`, //订单详情
  'rule.menu': `RULE ENGINE`, //规则引擎
  'rule.field.menu': `FIELD MANAGEMENT`, //字段管理
  'rule.field.cfpm.menu': `SYSTEM FIELDS`, //系统字段
  'rule.field.tvf.menu': `TEMPORARY VARIABLES`, //临时变量
  'rule.rules.menu': `RULES MANAGEMENT`, //规则管理
  'rule.models.menu': `MODEL MANAGEMENT`, //模型管理
  'rule.decision.menu': `DECISION DIAGRAM MANAGEMENT`, //决策图管理
  'rule.decision.mgt.menu': `DECISION DIAGRAM MANAGEMENT`, //决策图管理
  'rule.decision.version.menu': `DECISION DIAGRAM VERSION MANAGEMENT`, //决策图版本管理
  'rule.decision.validation.menu': `DECISION DIAGRAM VALIDATION`, //决策图复核
  'rule.decision.test.menu': `DECISION DIAGRAM TESTING`, //决策图测试
  'rule.decision.tests.menu': `DECISION DIAGRAM BATCH TESTING`, //决策图批量测试
  'login.menu': `LOGIN`, //登录
  'ec.report.menu': `E-BUSINESS INDICATORS`, //电商指标
  'voucher.menu': `VOUCHERS`, //优惠券中心
  'voucher.mgt.menu': `VOUCHERS MANAGEMENT`, //优惠券管理
  'voucher.mgt.volume.menu': `VOLUME DISCOUNT VOUCHER`, //满减券
  'voucher.mgt.pricevalue.menu': `PRICE-BREAK DISCOUNT VOUCHER(VALUE)`, //折扣券
  'voucher.mgt.exchange.menu': `EXCHANGE VOUCHER`, //兑换券
  'voucher.mgt.pricequantity.menu': `PRICE-BREAK DISCOUNT VOUCHER(QUANTITY)`, //满折券
  'voucher.writeoff.menu': `VOUCHERS WRITE OFF`, //优惠券核销
  'voucher.data.menu': `VOUCHERS DATA`, //优惠券数据

  'item.menu': `ITEM MANAGEMENT`, //商品管理
  'item.gift.menu': `GIFT MANAGEMENT`, //礼品管理
  'item.gift.add.menu': `添加礼品`, //添加礼品
  'item.gift.edit.menu': `编辑礼品`, //编辑礼品
  'item.gift.view.menu': `查看礼品`, //查看礼品
  'wechat.menu': `WECHAT MANAGEMENT`, //微信管理
  'wechat.authorize.menu': `AUTHORIZE`, //账号授权
  'wechat.official.menu': `OFFICIAL ACCOUNT MESSAGE`, //公众号模板消息
  'wechat.official.add.menu': `ADD TEMPLET`, //添加模板
  'wechat.official.edit.menu': `EDIT TEMPLET`, //编辑模板
  'message.menu': `MESSAGE`, //短信管理
  'message.templet.menu': `MESSAGE TEMPLET`, //短信模板
  'message.templet.add.menu': `ADD TEMPLET`, //新增模板

  'report.menu': ``, //报表中心
  'report.newpurchased.menu': `NEW PURCHASED MEMBERS`, //新增有购买会员
  'report.health.menu': `BRAND HEALTH CHECK`, //Brand Health Check
  'report.perform_sales.menu': `PERFORM SALES`, //剧目销售报表
  'report.bigscreen.menu': `BIG SCREEN`, //全域大屏
  'report.retail.menu': `RETAIL EXCELLENCE PROJECT 2021-2022`, //Retail Excellence Project 2021-2022
  'report.retail.detail.menu': `VIP DETAIL`, //会员详情
  'data.tools.menu': `DATA TOOLS`, // 取数工具

  'login.n01.lbl01': `LOGIN`,
  'login.n01.lbl02': `USER NAME`,
  'login.n01.placeholder03': `PLEASE ENTER`,
  'login.n01.lbl04': `PASSWORD`,
  'login.n01.placeholder05': `PASSWORD`,
  'login.n01.btn06': `LOGIN`,
  'login.n01.msg07': `PLEASE ENTER`,
  'login.n01.msg08': `PLEASE ENTER`,
  'login.n02.lbl01': `SCAN LOGIN FOR SAFER`,
  'login.n02.lbl02': `SCAN LOGIN`,
  'login.n02.lbl03': `OPEN WECHAT PROFESSIONAL TO SCAN LOGIN`,
  ...ec,
  ...marketing,
  ...adjustment,
  ...report,
  ...wechat,
  ...cm,
  ...blackList,
  ...coupon,
  ...coupon2,
  ...message,
  ...order,
  ...goods,
  'cm.search.n01.lbl01': `舒履会`,
  'cm.search.n01.lbl02': `MEMBER SEARCH`,
  'cm.search.n01.placeholder03': `ID/MP NUMBER`,
  'cm.search.n01.btn04': `RESET`,
  'cm.search.n01.btn05': `SEARCH`,
  'cm.analysis.n01.chb01': `STORES`,
  'cm.analysis.n01.rdo02': `BEGINNING`,
  'cm.analysis.n01.txt03': `TO`,
  'cm.analysis.n01.rdo04': `ENDING`,
  'cm.analysis.n01.btn05': `RESET`,
  'cm.analysis.n01.btn06': `SEARCH`,
  'cm.analysis.d01.rdo01': `DATE `,
  'cm.analysis.d01.btn02': `DETAIL`,
  'cm.analysis.n02.lbl01': `NEW MEMBERS`,
  'cm.analysis.n02.lbl02': `NEW PAID MEMBERS`,
  'cm.analysis.n02.lbl03': `ORDERS`,
  'cm.analysis.n02.lbl04': `PAIRS`,
  'cm.analysis.n02.lbl05': `SALES`,
  'cm.analysis.n02.lbl06': `ORDER(S) OF NEW MEMBERS`,
  'cm.analysis.n02.lbl07': `ORDER(S) OF OLD MEMBERS`,
  'cm.analysis.n02.lbl08': `ORDER(S) OF NON MEMBERS`,
  'cm.analysis.c01.lbl01': `REGION`,
  'cm.analysis.c01.lbl02': `STORE NO.`,
  'cm.analysis.c01.lbl03': `STORE NAME`,
  'cm.analysis.c01.lbl04': `STORE TYPE`,
  'cm.analysis.c01.lbl05': `NEW MEMBERS`,
  'cm.analysis.c01.lbl06': `ORDERS`,
  'cm.analysis.c01.lbl07': `NEW PAID MEMBERS`,
  'cm.analysis.c01.lbl08': `PAIRS`,
  'cm.analysis.c01.lbl09': `SALES`,
  'cm.analysis.c01.lbl10': `ORDER(S) OF NEW MEMBERS`,
  'cm.analysis.c01.lbl11': `ORDER(S) OF OLD MEMBERS`,
  'cm.analysis.c01.lbl12': `ORDER(S) OF NON MEMBERS`,
  'cm.analysis.c01.tip13': `New Members: Number of new members.`,
  'cm.analysis.c01.tip14': `Order(s) of New Members: Percentage of orders of new members in All Orders`,
  'cm.analysis.c01.tip15': `Order(s) of Old Members: Percentage of orders of old members in All Orders`,
  'cm.analysis.c01.tip16': `Order(s) of Non Members: Percentage of orders of non members in All Orders`,
  'cm.analysis.c01.tip17': `Sales refer to the order of shoes and accessories, and do not include gift, work shoes and rial products`,

  'item.gift.n01.lbl01': `GIFT ID`,
  'item.gift.n01.lbl02': `GIFT TITLE`,
  'item.gift.n01.rdo03': `GIFT STATUS`,
  'item.gift.n01.rdo04': `GIFT GROUP`,
  'item.gift.n01.rdo05': `GIFT ENTITY`,
  'item.gift.n01.rdo06': `GIFT TYPE`,
  'item.gift.n02.btn01': `ADD GIFT`,
  'item.gift.n02.btn02': `EXPORT`,
  'item.gift.c01.lbl01': `GIFT ID`,
  'item.gift.c01.lbl02': `GIFT TITLE`,
  'item.gift.c01.lbl03': `GIFT STATUS`,
  'item.gift.c01.lbl04': `GIFT GROUP`,
  'item.gift.c01.lbl05': `GIFT TYPE`,
  'item.gift.c01.lbl06': `EXCHANGE POINTS`,
  'item.gift.c01.lbl07': `ISSUED`,
  'item.gift.c01.lbl08': `REMAINING`,
  'item.gift.c01.lbl09': `ADD TIME`,
  'item.gift.c01.lbl10': `GIFT STATUS`,
  'item.gift.c01.lbl11': `ACTION`,
};
